import * as React from "react";

function OverallComments(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 29 29" fill="none" {...props}>
      <path
        d="M16.75 6.083h10.667M22.083.75v10.667"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.215 24.084c-1.733-.17-3.032-.691-3.903-1.562C.75 20.96.75 18.446.75 13.417v-.666c0-5.029 0-7.543 1.562-9.105 1.562-1.562 4.076-1.562 9.105-1.562h2m-6.667 20c-.274 1.336-1.496 4.222-.246 5.154.654.475 1.696-.033 3.78-1.049 1.461-.713 2.941-1.53 4.539-1.898.585-.134 1.18-.19 1.927-.207 5.028 0 7.543 0 9.105-1.562 1.491-1.492 1.558-3.851 1.561-8.438"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M8.75 16.75h8m-8-6.666h4"
        stroke="#333"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default OverallComments;
